import { render, staticRenderFns } from "./DeliveryDetail.vue?vue&type=template&id=164778aa"
import script from "./DeliveryDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports